import React from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import { Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FormDialog from './FormDialog';
import List from './List';
import { openCustomBracketSetForm } from '../../reducers/customBracketSets';

const Main = ({ organization, onCreate, otherActions, isManagement }) => {
  if (!organization) {
    return null;
  }

  return (
    <Container maxWidth="xl">
      {!isManagement && (
        <Box m={2} mb={0}>
          <Typography variant="h5">Custom Bracket Sets</Typography>
        </Box>
      )}
      <Box display="flex" justifyContent="flex-start" m={2}>
        {otherActions}
        <Button
          variant="contained"
          color="primary"
          disabled={!organization.enable_custom_bracket_sets}
          onClick={onCreate}
        >
          Create
        </Button>
      </Box>
      {!organization.enable_custom_bracket_sets && (
        <Box mx={2} mb={2}>
          <Typography color="textSecondary">
            Custom bracket sets are not enabled for this organization.
          </Typography>
        </Box>
      )}
      {organization.enable_custom_bracket_sets && (
        <>
          <List organizationId={organization.id} />
          <FormDialog organizationId={organization.id} />
        </>
      )}
    </Container>
  );
};

Main.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  organization: PropTypes.object,
  onCreate: PropTypes.func.isRequired,
  otherActions: PropTypes.element,
  isManagement: PropTypes.bool.isRequired
};

Main.defaultProps = {
  organization: null,
  otherActions: null
};

export default connect(
  (state, props) => {
    return {
      organization: props.organization || state.auth.currentOrganization,
      isManagement: state.auth.isManagement
    };
  },
  dispatch => {
    return {
      onCreate: () =>
        dispatch(
          openCustomBracketSetForm({
            name: '',
            teeth: []
          })
        )
    };
  }
)(Main);
